module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Undo-32da60bc245fd967aaf7fbd854539602.svg";